export function quizOrQuestionnaire(isGraded) {
  if (!isGraded) return 'QUESTIONNAIRE';
  return 'QUIZ';
}
